module.exports = __webpack_public_path__ + "img/voice.45de7a46.svg";